import { render, staticRenderFns } from "./ParticipantHeader.vue?vue&type=template&id=ea347360&"
import script from "./ParticipantHeader.vue?vue&type=script&lang=js&"
export * from "./ParticipantHeader.vue?vue&type=script&lang=js&"
import style0 from "./ParticipantHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports